import { render } from "./Especificaciones.vue?vue&type=template&id=7b3ffaae"
import script from "./Especificaciones.vue?vue&type=script&lang=js"
export * from "./Especificaciones.vue?vue&type=script&lang=js"

import "./Especificaciones.vue?vue&type=style&index=0&id=7b3ffaae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__